import Text from '#components/a/Text'
import Ausbildungsnachweis from '#components/m/Ausbildungsnachweis'
import {routeHelper} from '#config/routeKeys'
import {usePermissions} from '#hooks/usePermissions'
import i18n from 'i18next'
import PropTypes from 'prop-types'
import React from 'react'
import {useNavigate} from 'react-router-dom'

function NachweisListe({ausbildungsnachweise, modifier, canVerify}) {
  const permissions = usePermissions()
  const canFilter = permissions.meineAzubis.canFilterAzubisByMyAbteilungen
  const verifyerType = canFilter ? 'verifier_fachabteilung' : 'verifier'
  const listModifier = canVerify ? verifyerType : 'editor'
  const textModifier = modifier || listModifier
  const noAusbildungsnachweisExists = ausbildungsnachweise.length === 0
  const navigate = useNavigate()

  const openNachweis = nachweis => {
    if (nachweis.id) {
      navigate(routeHelper.ausbildungsnachweisDetail(nachweis.id))
    } else {
      navigate(routeHelper.newAusbildungsnachweisWithNummer(nachweis.nummer))
    }
  }

  if (noAusbildungsnachweisExists) {
    return (
      <div className={`nachweisliste__list nachweisliste__list--${listModifier}`}>
        <Text
          data-testid={`nachweise-empty-${textModifier}`}
          text={i18n.t(`ausbildungsnachweiseOverview_noentries_${textModifier}`)}
        />
      </div>
    )
  }
  return (
    <div className={`nachweisliste__list nachweisliste__list--${listModifier}`}>
      {ausbildungsnachweise.map((nachweis, index) => (
        <Ausbildungsnachweis
          event={() => openNachweis(nachweis)}
          key={(nachweis.id ?? 0) + index}
          id={nachweis.id}
          nummer={nachweis.nummer}
          status={nachweis.status}
          text={nachweis.status}
          canVerify={canVerify}
          dateRange={nachweis.dateRange}
          hasComment={nachweis.hasCommentFromFreigabe}
        />
      ))}
    </div>
  )
}

NachweisListe.propTypes = {
  ausbildungsnachweise: PropTypes.array,
  modifier: PropTypes.string,
  canVerify: PropTypes.bool,
}

export default NachweisListe
